import { lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import RoutePrivate from 'components/common/route-private';
import { config } from 'config';

const DeleteAccounts = lazy(() => import('components/QA/deleteAccounts'))
const DecVipPushTest = lazy(() => import('components/QA/decVipPushTest'))
const CustomPushTest = lazy(() => import('components/QA/customPushTest'))

const QA = () => {
  let { path } = useRouteMatch();

  return (
    <Suspense fallback={<CircularProgress />}>
      <Switch>

        <RoutePrivate exact path={`${path}/deleteaccounts`} component={DeleteAccounts} permission='LIVE SERVICE' />
        <RoutePrivate exact path={`${path}/decvippushtest`} component={DecVipPushTest} permission='LIVE SERVICE' />
        <RoutePrivate exact path={`${path}/custompushtest`} component={CustomPushTest} permission='LIVE SERVICE' />

        <Route path='*'>
          <Redirect to={`/${config.game}/dashboard/notfound`} />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default QA;
